<script>
import { Cell, Row, Col, Tabs, Tab, Dialog, Toast, Empty } from 'vant'
import Game from '@/tbs/model/vo/Game'
import GameEdit from '@/views/org/GameEdit'
import GameScoreInput from '@/components/org/GameScoreInput'
import GroupPicker from '@/components/org/GroupPicker'
import GameStatsMode from '@/components/org/GameStatsMode'
import GameEventMode from '@/components/org/GameEventMode'
import BottomToolbar from '@/components/org/BottomToolbar'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-game-manage',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-row': Row,
        'van-col': Col,
        'van-tabs': Tabs,
        'van-tab': Tab,
        'van-empty': Empty,
        'game-edit': GameEdit,
        'game-score-input': GameScoreInput,
        'group-picker': GroupPicker,
        'game-stats-mode': GameStatsMode,
        'game-event-mode': GameEventMode,
        'bottom-toolbar': BottomToolbar
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            game: {
                id: null,
                matchId: null,
                matchGroupId: null,
                seq: null,
                status: null,
                roundSeq: null,
                startDateTime: null,
                homeTeamId: null,
                homeTeamName: null,
                homeTeamLogoUrl: null,
                homeTeamSuit: null,
                homeTeamScore: null,
                homeTeamPenaltyScore: null,
                awayTeamId: null,
                awayTeamName: null,
                awayTeamLogoUrl: null,
                awayTeamSuit: null,
                awayTeamScore: null,
                awayTeamPenaltyScore: null,
                refereeList: null,
            },
            match: {},
            referee: {
                roles: null,
                options: null,
                items: null
            },
            gameScoreList: null,
            stats: {
                playerList: null,
                eventList: null,
            },
            role: {
                isManager: null,
                isReferee: null,
            },
            selectedTab: null,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        matchGameSeq() {
            if (this.locale.localeProp) {
                return this.locale.localeProp('match-game-seq', {seq: this.game.seq})
            }
            else {
                return ''
            }
        },
        homeTeamSuitUrl() {
            console.log('homeTeamSuitUrl', this.game.homeTeamSuit)
            const url = this.getSuitUrlByValue(this.game.homeTeamSuit)
            console.log('url', url)
            return url ? url : ''
        },
        awayTeamSuitUrl() {
            const url = this.getSuitUrlByValue(this.game.awayTeamSuit)
            return url ? url : ''
        },
        scoreBoardStatusClass() {
            if (this.game.homeTeamScore && this.game.awayTeamScore) {
                return {
                    'main-text': true,
                    'main-color': true
                }
            }
            else {
                return {
                    'minor-text': true,
                    'minor-color': true
                }
            }
        },
        scoreBoardStatus() {
            if (this.game.homeTeamScore && this.game.awayTeamScore) {
                if (this.game.homeTeamPenaltyScore && this.game.awayTeamPenaltyScore) {
                    return Number(this.game.homeTeamScore) + Number(this.game.homeTeamPenaltyScore) 
                        + ' : ' 
                        + (Number(this.game.awayTeamScore) + Number(this.game.awayTeamPenaltyScore))
                }
                else {
                    return this.game.homeTeamScore + ' : ' + this.game.awayTeamScore
                }
            }
            else if (this.game.status) {
                return this.locale.localeProp('game-status-' + this.game.status)
            }
            else {
                return 'VS'
            }
        },
        isPlayerStatsMode() {
            console.log('@isPlayerStatsMode', this.match.dataMode)
            return this.match.dataMode == '2'
        },
        isStatsExisted() {
            console.log('isStatsExisted', this.match.dataMode, this.stats)
            if (this.match.dataMode == '1') {
                if (this.stats.eventList && this.stats.eventList.length > 0) {
                    return true
                }
            }
            else if (this.match.dataMode == '2') {
                if (this.stats.playerList && this.stats.playerList.length > 0) {
                    return true
                }
            }
            return false
        },
        homePlayerStats() {
            if (this.stats.playerList) {
                return this.stats.playerList.filter((player) => player.teamId === this.game.homeTeamId)
            }
            return []
        },
        awayPlayerStats() {
            if (this.stats.playerList) {
                return this.stats.playerList.filter((player) => player.teamId === this.game.awayTeamId)
            }
            return []
        },
        gameScoreDescriptionField() {
            if (this.gameScoreList && this.gameScoreList.length > 0) {
                let currentItem = this.gameScoreList[0]
                return this.locale['recent-record'] + this.locale.semicolon
                    + currentItem.submitTime + '        ' + this.locale.recorder
                    + this.locale.semicolon + currentItem.submitName
            }
            return ''
        },
        historicalGameScoreList() {
            if (this.gameScoreList && this.gameScoreList.length > 1) {
                const itemList = []
                for (let i = 1; i < this.gameScoreList.length; i++) {
                    let item = this.gameScoreList[i]
                    let scoreStr = ''
                    scoreStr += this.locale.localeProp('game-score', {
                        homeScore: item.homeTeamScore,
                        awayScore: item.awayTeamScore
                    })
                    if (item.homeTeamScore == item.awayTeamScore && item.homeTeamPenaltyScore && item.awayTeamPenaltyScore) {
                        scoreStr += ' ' + this.locale.localeProp('game-penalty-score', {
                            homePenaltyScore: item.homeTeamPenaltyScore,
                            awayPenaltyScore: item.awayTeamPenaltyScore
                        })
                    }
                    itemList.push({
                        score: scoreStr,
                        submit: item.submitName + ' ' + item.submitTime
                    })
                }
                return itemList
            }
            return []
        },
        hasPenaltyScore() {
            console.log('hasPenaltyScore', this.game.homeTeamScore == this.game.awayTeamScore, this.game.homeTeamPenaltyScore ? true : false)
            if (this.game.homeTeamScore == this.game.awayTeamScore && this.game.homeTeamPenaltyScore && this.game.awayTeamPenaltyScore) {
                return true
            }
            return false
        },
        scoreBoardPenaltyStatus() {
            if (this.game.homeTeamPenaltyScore && this.game.awayTeamPenaltyScore) {
                return this.locale.localeProp('game-penalty-status', {
                    homePenaltyScore: this.game.homeTeamPenaltyScore,
                    awayPenaltyScore: this.game.awayTeamPenaltyScore,
                })
            }
            return ''
        },
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onTabClick(index) {
            console.log('onTabClick', index)
            if (index != this.selectedTab) {
                this.selectedTab = Number(index)
            }
            if (index == 2 || index == 5) {
                Toast(this.locale['coming-soon'])
            }
            this.$emit('custom-event', {
                type: 'tab',
                data: {
                    index: index
                }
            })
        },
        onGameEditCustomEvent(event) {
            console.log('onGameEditCustomEvent', arguments)
            this.$emit('custom-event', event)
        },
        onDeleteBtnClick() {
            console.log('onDeleteBtnClick')
            Dialog.confirm({
                title: this.locale['delete-game'],
                message: this.locale['delete-game-confirm-message']
            }).then(() => {
                // on confirm
                this.$emit('custom-event', {
                    type: 'delete'
                })
            }).catch(() => {
                // on cancel
            })
        },
        onRefereeDataChange(data) {
            console.log('onRefereeDataChange', data)
            this.$emit('custom-event', {
                type: 'submit',
                data: {
                    id: this.game.id,
                    matchGroupId: this.game.matchGroupId,
                    refereeList: data,
                }
            })
        },
        onGameScoreDataChange(data) {
            console.log('onGameScoreDataChange', data)
            if (data.homeTeamScore == data.awayTeamScore) {
                if (data.homeTeamPenaltyScore == '' || data.awayTeamPenaltyScore == '') {
                    return
                }
                else if (data.homeTeamPenaltyScore == data.awayTeamPenaltyScore) {
                    return
                }
                else if (Math.abs(Number(data.homeTeamPenaltyScore) - Number(data.awayTeamPenaltyScore)) != 1) {
                    return
                }
            }
            this.game.homeTeamScore = data.homeTeamScore
            this.game.awayTeamScore = data.awayTeamScore
            this.game.homeTeamPenaltyScore = data.homeTeamPenaltyScore
            this.game.awayTeamPenaltyScore = data.awayTeamPenaltyScore
            this.$emit('custom-event', {
                type: 'submit',
                data: {
                    id: this.game.id,
                    matchGroupId: this.game.matchGroupId,
                    homeTeamScore: this.game.homeTeamScore,
                    awayTeamScore: this.game.awayTeamScore,
                    homeTeamPenaltyScore: this.game.homeTeamPenaltyScore,
                    awayTeamPenaltyScore: this.game.awayTeamPenaltyScore,
                }
            })
        },
        onAddDataBtnClick() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: this.match.dataMode == '1' ? 'OrgCreateGameEvent' : 'OrgCreateGameStats',
                    params: {
                        gameId: this.game.id
                    },
                    query: {
                        homeTeamId: this.game.homeTeamId,
                        homeTeamName: this.game.homeTeamName,
                        awayTeamId: this.game.awayTeamId,
                        awayTeamName: this.game.awayTeamName,
                        matchGroupId: this.game.matchGroupId
                    }
                }
            })
        },
        onDataModeLinkClick() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditMatchRule',
                    params: {
                        id: this.game.matchGroupId
                    },
                    query: {
                        homeTeamId: this.game.homeTeamId,
                        homeTeamName: this.game.homeTeamName,
                        awayTeamId: this.game.awayTeamId,
                        awayTeamName: this.game.awayTeamName,
                    }
                }
            })
        },
        onPlayerStatsEdit(player) {
            console.log('onPlayerStatsEdit', player)
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditGameStats',
                    params: {
                        gameId: this.game.id,
                        id: player.id,
                    },
                    query: {
                        playerId: player.id,
                        teamId: player.teamId,
                        homeTeamId: this.game.homeTeamId,
                        homeTeamName: this.game.homeTeamName,
                        awayTeamId: this.game.awayTeamId,
                        awayTeamName: this.game.awayTeamName,
                        matchGroupId: this.game.matchGroupId
                    }
                }
            })
        },
        onGameEventEdit(event) {
            console.log('onGameEventEdit', event)
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditGameEvent',
                    params: {
                        id: event.id,
                        gameId: this.game.id
                    },
                    query: {
                        homeTeamId: this.game.homeTeamId,
                        homeTeamName: this.game.homeTeamName,
                        awayTeamId: this.game.awayTeamId,
                        awayTeamName: this.game.awayTeamName,
                        matchGroupId: this.game.matchGroupId
                    }
                }
            })
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        getSuitUrlByValue(value) {
            if (value) {
                const suitList = (new Game).suitList
                for (let i = 0; i < suitList.length; i++) {
                    let suit = suitList[i]
                    if (suit.value == value) {
                        return suit.url
                    }
                }
            }
            return
        },
    },
}
</script>

<template>
    <div class="game-manage">
        <van-cell :title="matchGameSeq"/>
        <div class="game-summary relative t-inner-margin">
            <div class="game-summary-bg">
               <div class="body text-center u-outer-padding">
                    <!--<div>
                        <span class="minor-text minor-color">{{ locale['game-referee-empty-field'] }}</span>
                    </div>-->
                    <div class="t-wide-margin">
                        <van-row type="flex" justify="center">
                            <van-col span="10" class="justify-right vertical-center">
                                <span class="r-inner-margin">{{ game.homeTeamName }}</span>
                                <img v-if="game.homeTeamLogoUrl"
                                    class="team-logo corner-round" 
                                    :src="adjustImageSize(game.homeTeamLogoUrl, 50, 50)"
                                    style="width: 25px; height: 25px;"
                                />
                                <img v-else
                                    class="team-logo corner-round" 
                                    src="@/assets/org/logo-symbol.png"
                                    style="width: 25px; height: 25px;"
                                />
                            </van-col>
                            <van-col span="4" v-if="hasPenaltyScore" >
                                <div class="justify-center vertical-center"><span :class="scoreBoardStatusClass">{{ scoreBoardStatus }}</span></div>
                                <div class="justify-center vertical-center"><span class="minor-text minor-color">{{ scoreBoardPenaltyStatus }}</span></div>
                            </van-col>
                            <van-col span="4" v-else class="justify-center vertical-center">
                                <span :class="scoreBoardStatusClass">{{ scoreBoardStatus }}</span>
                            </van-col>
                            <van-col span="10" class="text-left justify-left vertical-center">
                                <img v-if="game.awayTeamLogoUrl"
                                    class="team-logo corner-round" 
                                    :src="adjustImageSize(game.awayTeamLogoUrl, 50, 50)"
                                    style="width: 25px; height: 25px;"
                                />
                                <img v-else
                                    class="team-logo corner-round" 
                                    src="@/assets/org/logo-symbol.png"
                                    style="width: 25px; height: 25px;"
                                />
                                <span class="l-inner-margin">{{ game.awayTeamName }}</span>
                            </van-col>
                        </van-row>
                    </div>
                </div>
            </div>
            <div class="left-corner">
                <div class="left-corner-bg">
                    <img v-if="homeTeamSuitUrl" :src="homeTeamSuitUrl"/>
                </div>
            </div>
            <div class="right-corner">
                <div class="right-corner-bg">
                    <img v-if="awayTeamSuitUrl" :src="awayTeamSuitUrl"/>
                </div>
            </div>
        </div>
        <div class="t-outer-margin">
            <van-tabs 
                v-model="selectedTab" 
                sticky
                offset-top="43"
                @click="onTabClick"
            >
                <van-tab :title="locale['basic-info']">
                    <game-edit ref="gameEdit" @custom-event="onGameEditCustomEvent"/>
                    <div class="delete-section t-outer-margin b-outer-margin">
                        <div 
                            class="cell-height vertical-center justify-center minor-color" 
                            @click="onDeleteBtnClick">
                            <van-icon name="delete-o" size="20"/>
                            <span class="l-inner-margin minor-text">{{ locale['delete-game'] }}</span>
                        </div>
                    </div>
                </van-tab>
                <van-tab :title="locale['referee']">
                    <group-picker
                        :roles="referee.roles"
                        :options="referee.options"
                        :items="referee.items"
                        :disabled="!role.isManager"
                        @change-data="onRefereeDataChange"
                    />
                </van-tab>
                <van-tab :title="locale['live-broadcast']">
                </van-tab>
                <van-tab :title="locale['score']">
                    <game-score-input 
                        :homeTeamName="game.homeTeamName"
                        :awayTeamName="game.awayTeamName"
                        :homeTeamScore="game.homeTeamScore"
                        :awayTeamScore="game.awayTeamScore"
                        :homeTeamPenaltyScore="game.homeTeamPenaltyScore"
                        :awayTeamPenaltyScore="game.awayTeamPenaltyScore"
                        :description="gameScoreDescriptionField"
                        @change-data="onGameScoreDataChange"
                    />
                    <div v-if="historicalGameScoreList.length > 0">
                        <div class="u-outer-padding">
                            <span class="minor-text minor-color">{{ locale['historical-record'] }}</span>
                        </div>
                        <div>
                            <van-cell 
                                v-for="(item, index) in historicalGameScoreList"
                                :key="index"
                                :title="item.score"
                                :value="item.submit"
                                title-class="record-score"
                                value-class="record-submit"
                            />
                        </div>
                    </div>
                </van-tab>
                <van-tab :title="locale['stats']" class="bg-white">
                    <div v-if="isStatsExisted">
                        <game-stats-mode 
                            v-if="isPlayerStatsMode"
                            class="h-outer-padding"
                            :homePlayerList="homePlayerStats"
                            :awayPlayerList="awayPlayerStats"
                            @edit-player="onPlayerStatsEdit"
                        />
                        <game-event-mode 
                            v-else
                            class="h-outer-padding"
                            :homeTeamId="game.homeTeamId"
                            :awayTeamId="game.awayTeamId"
                            :eventList="stats.eventList"
                            @edit-event="onGameEventEdit"
                        />
                    </div>
                    <div v-else @click="onAddDataBtnClick">
                        <van-empty 
                            :description="locale['stats-empty-hint']"
                            image="search"
                        />
                    </div>
                    <bottom-toolbar 
                        type="link-button" 
                        :mainButtonLabel="locale['add-data']"
                        :minorLinkLabel="match.dataModeLabel"
                        @click-main-button="onAddDataBtnClick"
                        @click-minor-link="onDataModeLinkClick"
                    />
                </van-tab>
                <van-tab :title="locale['complete-game']">
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<style scoped>
.game-summary {
    min-height: 65px;    /* 80px */
    height: 100%;
    overflow-x: hidden;
}
.game-summary-bg {
    width: 375px;
    height: 100%;
    background: #FFF;
}
.left-corner-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    border-right: 45px solid transparent;
    border-top: 45px solid #F2F3F5;
}
.left-corner-bg img {
    width: 20px;
    height: 20px;
    position: absolute;
    top: -42px;
    left: 2px;
    transform: rotate(-45deg);
}
.right-corner-bg {
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-left: 45px solid transparent;
    border-top: 45px solid #F2F3F5;
}
.right-corner-bg img {
    width: 20px;
    height: 20px;
    position: absolute;
    top: -42px;
    right: 2px;
    transform: rotate(45deg);
}
.record-score,
.record-submit {
    color: #969799;
}
</style>